export const fallbackUser = {
  displayName: 'Unknown User',
  initials: 'UU',
}
